<template>
  <div>
    <div class="container">
      <div class="row section-separator">
        <div class="section-title col-sm-12 wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.1s"
          style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.1s; animation-name: none;">
          <h3>Recent Portfolio</h3>
        </div>
        <div class="part col-sm-12">
          <div class="portfolio-nav col-sm-12" id="filter-button">
            <ul>
              <li data-filter="*" class="current wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.1s"
                style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.1s; animation-name: none;">
                <span>All Categories</span>
              </li>
              <li data-filter=".user-interface" class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s"
                style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: none;">
                <span>Web Design</span>
              </li>
              <li data-filter=".branding" class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.3s"
                style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.3s; animation-name: none;">
                <span>Branding</span>
              </li>
              <li data-filter=".mockup" class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.4s"
                style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.4s; animation-name: none;">
                <span>Mockups</span>
              </li>
              <li data-filter=".ui" class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s"
                style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.5s; animation-name: none;">
                <span>Photography</span>
              </li>
            </ul>
          </div>
          <div class="mh-project-gallery col-sm-12 wow fadeInUp" id="project-gallery" data-wow-duration="0.8s"
            data-wow-delay="0.5s"
            style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.5s; animation-name: none;">
            <div class="portfolioContainer row" style="position: relative; height: 987px;">
              <div class="grid-item col-md-4 col-sm-6 col-xs-12 user-interface"
                style="position: absolute; left: 0px; top: 0px;">
                <figure>
                  <img src="/static/images/portfolio/g1.jpg" alt="img04">
                  <figcaption class="fig-caption">
                    <i class="fa fa-search"></i>
                    <h5 class="title">Creative Design</h5>
                    <span class="sub-title">Photograpy</span>
                    <a data-fancybox="" data-src="#mh"></a>
                  </figcaption>
                </figure>
              </div>
              <div class="grid-item col-md-4 col-sm-6 col-xs-12 ui mockup"
                style="position: absolute; left: 370px; top: 0px;">
                <figure>
                  <img src="/static/images/portfolio/g2.png" alt="img04">
                  <figcaption class="fig-caption">
                    <i class="fa fa-search"></i>
                    <h5 class="title">Creative Design</h5>
                    <span class="sub-title">Photograpy</span>
                    <a href="/static/images/portfolio/g2.png" data-fancybox="" data-src="#mh"></a>
                  </figcaption>
                </figure>
              </div>
              <div class="grid-item col-md-4 col-sm-6 col-xs-12 user-interface"
                style="position: absolute; left: 740px; top: 0px;">
                <figure>
                  <img src="/static/images/portfolio/g3.png" alt="img04">
                  <figcaption class="fig-caption">
                    <i class="fa fa-search"></i>
                    <h5 class="title">Creative Design</h5>
                    <span class="sub-title">Photograpy</span>
                    <a href="/static/images/portfolio/g3.png" data-fancybox="" data-src="#mh"></a>
                  </figcaption>
                </figure>
              </div>
              <div class="grid-item col-md-4 col-sm-6 col-xs-12 branding"
                style="position: absolute; left: 370px; top: 261px;">
                <figure>
                  <img src="/static/images/portfolio/g5.png" alt="img04">
                  <figcaption class="fig-caption">
                    <i class="fa fa-search"></i>
                    <h5 class="title">Creative Design</h5>
                    <span class="sub-title">Photograpy</span>
                    <a href="/static/images/portfolio/g5.png" data-fancybox="" data-src="#mh"></a>
                  </figcaption>
                </figure>
              </div>
              <div class="grid-item col-md-4 col-sm-6 col-xs-12 user-interface"
                style="position: absolute; left: 0px; top: 376px;">
                <figure>
                  <img src="/static/images/portfolio/g4.png" alt="img04">
                  <figcaption class="fig-caption">
                    <i class="fa fa-search"></i>
                    <h5 class="title">Creative Design</h5>
                    <span class="sub-title">Photograpy</span>
                    <a href="/static/images/portfolio/g4.png" data-fancybox="" data-src="#mh"></a>
                  </figcaption>
                </figure>
              </div>
              <div class="grid-item col-md-4 col-sm-6 col-xs-12 branding"
                style="position: absolute; left: 740px; top: 408px;">
                <figure>
                  <img src="/static/images/portfolio/g6.png" alt="img04">
                  <figcaption class="fig-caption">
                    <i class="fa fa-search"></i>
                    <h5 class="title">Creative Design</h5>
                    <span class="sub-title">Photograpy</span>
                    <a href="/static/images/portfolio/g6.png" data-fancybox="" data-src="#mh"></a>
                  </figcaption>
                </figure>
              </div>
              <div class="grid-item col-md-4 col-sm-6 col-xs-12 branding"
                style="position: absolute; left: 370px; top: 522px;">
                <figure>
                  <img src="/static/images/portfolio/g8.png" alt="img04">
                  <figcaption class="fig-caption">
                    <i class="fa fa-search"></i>
                    <h5 class="title">Creative Design</h5>
                    <span class="sub-title">Photograpy</span>
                    <a href="/static/images/portfolio/g8.png" data-fancybox="" data-src="#mh"></a>
                  </figcaption>
                </figure>
              </div>
              <div class="grid-item col-md-4 col-sm-6 col-xs-12 ui" style="position: absolute; left: 0px; top: 638px;">
                <figure>
                  <img src="/static/images/portfolio/g9.png" alt="img04">
                  <figcaption class="fig-caption">
                    <i class="fa fa-search"></i>
                    <h5 class="title">Creative Design</h5>
                    <span class="sub-title">Photograpy</span>
                    <a href="/static/images/portfolio/g9.png" data-fancybox="" data-src="#mh"></a>
                  </figcaption>
                </figure>
              </div>
              <div class="grid-item col-md-4 col-sm-6 col-xs-12 branding"
                style="position: absolute; left: 740px; top: 669px;">
                <figure>
                  <img src="/static/images/portfolio/g7.jpg" alt="img04">
                  <figcaption class="fig-caption">
                    <i class="fa fa-search"></i>
                    <h5 class="title">Creative Design</h5>
                    <span class="sub-title">Photograpy</span>
                    <a href="/static/images/portfolio/g7.jpg" data-fancybox="gallery"></a>
                  </figcaption>
                </figure>
              </div>
            </div> <!-- End: .grid .project-gallery -->
          </div> <!-- End: .grid .project-gallery -->
        </div> <!-- End: .part -->
      </div> <!-- End: .row -->
    </div>
    <div class="mh-portfolio-modal" id="mh">
      <div class="container">
        <div class="row mh-portfolio-modal-inner">
          <div class="col-sm-5">
            <h2>Wrap - A campanion plugin</h2>
            <p>Wrap is a clean and elegant Multipurpose Landing Page Template.
              It will fit perfectly for Startup, Web App or any type of Web Services.
              It has 4 background styles with 6 homepage styles. 6 pre-defined color scheme.
              All variations are organized separately so you can use / customize the template very easily.</p>

            <p>It is a clean and elegant Multipurpose Landing Page Template.
              It will fit perfectly for Startup, Web App or any type of Web Services.
              It has 4 background styles with 6 homepage styles. 6 pre-defined color scheme.
              All variations are organized separately so you can use / customize the template very easily.</p>
            <div class="mh-about-tag">
              <ul>
                <li><span>php</span></li>
                <li><span>html</span></li>
                <li><span>css</span></li>
                <li><span>php</span></li>
                <li><span>wordpress</span></li>
                <li><span>React</span></li>
                <li><span>Javascript</span></li>
              </ul>
            </div>
            <a href="" class="btn btn-fill">Live Demo</a>
          </div>
          <div class="col-sm-7">
            <div class="mh-portfolio-modal-img">
              <img src="/static/images/pr-0.jif" alt="" class="img-fluid">
              <p>All variations are organized separately so you can use / customize the template very easily.</p>
              <img src="/static/images/pr-1.jif" alt="" class="img-fluid">
              <p>All variations are organized separately so you can use / customize the template very easily.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {

      }
    },
    components: {},
    created() {

    },
    mounted() {

    },
    computed: {

    },
    watch: {

    },
    methods: {

    }
  }

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Portfolio.vue